<template>
    <img id="star" :style="starcss" :src="resourcepath+'/images/'+starfilename+'.png?v=2'" />
  
</template>
<script>
import { mapState } from 'vuex'
import  {resourcepath} from '@/commonjs/commonfn.js'
import loadui from './loadui.vue'
export default {
  components: { loadui },
  props: ["starfilename"],
  name: 'starui',
  data() {
    return {
      "resourcepath":resourcepath,
    }
  },
  mounted() {},
  methods: {
   
  },
  computed: {
    ...mapState(['suodingtipcss', 'yujiazaicss', 'sharetipcontainercss', 'morentanchuangcss', 'chuangtitle', 'fn', 'jindu', 'starcss', 'isalljiazai','isplaybgmusic']),
  }
}

</script>
<style scoped>
#star {
  animation: 1.5s infinite start;
  -webkit-animation: 1.5s infinite start;
  bottom: 2.5%;
  left: 43.8%;
  position: absolute;
  width: 9%;
  display: none;
  z-index: 99;
}
@-webkit-keyframes start {

  0%,
  30% {
    opacity: 0;
    -webkit-transform: translate(0, 10px);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate(0, 0);
  }

  100% {
    opacity: 0;
    -webkit-transform: translate(0, -8px);
  }
}

@keyframes start {

  0%,
  30% {
    opacity: 0;
    transform: translate(0, 10px);
  }

  60% {
    opacity: 1;
    transform: translate(0, 0);
  }

  100% {
    opacity: 0;
    transform: translate(0, -8px);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/starui.vue